/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceHistoryInput
 */
export interface BalanceHistoryInput {
    /**
     * Request balance at given time in UTC Unix timestamp
     * @type {string}
     * @memberof BalanceHistoryInput
     */
    atDate?: string;
}

/**
 * Check if a given object implements the BalanceHistoryInput interface.
 */
export function instanceOfBalanceHistoryInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BalanceHistoryInputFromJSON(json: any): BalanceHistoryInput {
    return BalanceHistoryInputFromJSONTyped(json, false);
}

export function BalanceHistoryInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceHistoryInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'atDate': !exists(json, 'atDate') ? undefined : json['atDate'],
    };
}

export function BalanceHistoryInputToJSON(value?: BalanceHistoryInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'atDate': value.atDate,
    };
}

